import { ErrorItem } from '../components/ErrorsPresenter/ErrorsPresenter';

import { BannerPrice } from './banners';

export interface BannerPricesPopupState {
    isVisible: boolean;
    isOnProgress: boolean;
    isPriceFormVisible: boolean;
    bannerPrice: BannerPrice;
    errors: ErrorItem[];
}

export enum BannersPriceField {
    PREFIX = 'prefix',
    PRICE = 'price',
    PRICE_OLD = 'priceOld',
    CURRENCY = 'currency'
}
